import {getFormattedNumberWithSuffix} from './shared/utils/getFormattedNumberWithSuffix';

/**
 * 랭킹 리스트뷰의 메타리스트
 * 장르 - 뷰카운트 - 자가명
 */
export function getRankingMetaList({
  viewCount,
  authors,
  subcategory,
}: {
  viewCount?: number;
  authors?: string;
  subcategory?: string;
}) {
  return [
    ...(subcategory !== undefined ? [subcategory] : []),
    ...(viewCount !== undefined
      ? [getFormattedNumberWithSuffix(viewCount)]
      : []),
    ...(authors !== undefined ? [authors] : []),
  ];
}
